export type AppInsightsLike = {
	trackEvent: (event: { name: string; properties?: Record<string, string>; measurements?: Record<string, number> }) => void;
};

/**
 * Emits a custom event via AppInsights if the provided instance is available.
 */
export function trackTelemetryEvent(
	ai: AppInsightsLike | undefined | null,
	name: string,
	properties: Record<string, string>,
	measurements: Record<string, number>
): void {
	if (ai)
		ai.trackEvent({ name, properties, measurements });
}
